import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy {
  public currentPage;
  private urlChangeSub;
  constructor(private router: Router, private route: ActivatedRoute, public location: Location) { }

  ngOnInit(): void {
    this.urlChangeSub = this.location.onUrlChange(data => {
      if (this.location.path().match(/\/services/g) !== null) {
        this.currentPage = 'services'
      } else {
        this.currentPage = this.location.path()
      }
    })
  }

  ngOnDestroy(): void {
    if (this.urlChangeSub !== undefined) {
      this.urlChangeSub.unsubscribe();
    }
  }
  
}
